import {
  type Option,
  SelectComboField,
  type SelectComboFieldProps,
} from "components/Forms/SelectCombo/SelectCombo";
import { timeFilterEnum } from "kubb";

const TimeFilterEnumOptions: Option[] = [
  { label: "All", value: timeFilterEnum.ALL },
  { label: "30 minute", value: timeFilterEnum.MINUTE_30 },
  { label: "Hourly", value: timeFilterEnum.HOURLY },
  { label: "12 hourly", value: timeFilterEnum.HOUR_12 },
  { label: "Daily", value: timeFilterEnum.DAILY },
];

type TimeFilterEnumSelectProps = Omit<SelectComboFieldProps, "options">;

function TimeFilterEnumSelect(props: TimeFilterEnumSelectProps) {
  return <SelectComboField {...props} options={TimeFilterEnumOptions} />;
}

export default TimeFilterEnumSelect;
